import { render, staticRenderFns } from "./NoItems.vue?vue&type=template&id=75a6ae5e&"
import script from "./NoItems.vue?vue&type=script&lang=js&"
export * from "./NoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VImg,VListItemGroup})
